<template>
  <div>
    <template v-if="items.length > 0">
      <SubHeader :text="$t('ARTICLE-BUNDLE-PRODUCTLINE')" v-if="hasProductionLine" />
      <box v-if="hasProductionLine">
        <v-row no-gutters v-for="(attribute) in productionLineItems" :key="attribute">
          <v-col>
            <template v-if="attribute.attribute.isWritable && attribute.attribute.pivot.override != null">
              <i class="general--font">{{ attribute.attribute.pivot.override }}</i>
            </template>

            <template v-else>
              <span class="general--font">{{ attribute.attribute.pivot.value }}</span>
            </template>

            <v-tooltip top v-if="bundle.productionLineInfo && bundle.productionLineInfo != ''">
              <template v-slot:activator="{ on, attrs }">
                <v-icon bind="attrs" class="ml-1" v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span class="infoContainer" v-html="bundle.productionLineInfo"></span>
            </v-tooltip>

            <template v-if="attribute.attribute.isWritable">
              <v-icon :disabled="isReadonly" plain x-small left @click="editAttribute(attribute.attribute)" class="ml-2"
                >mdi-pencil</v-icon
              >
            </template>
          </v-col>
        </v-row>
      </box>
    </template>
    <v-row>
      <v-col cols="12">
        <ProductionSystem :bundle="propBundle"  @attributeUpdated="emitAttributeUpdated" @showTestResult="showTestResult"/>
      </v-col>
    </v-row>

    <template v-if="bundle.trays.length > 0">
      <SubHeader :text="$t('ARTICLE-BUNDLE-TRAY-SIMPLE_PATTERN')" />
      <box>
        <v-simple-table dense class="trays">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" id="bundle-tray">
                  <lang t="ARTICLE-BUNDLE-TRAY-WAREHOUSE"></lang>
                </th>
                <th class="text-left" id="bundle-tray-qty">
                  <lang t="ARTICLE-BUNDLE-TRAY-QTY"></lang>
                </th>
                <th class="text-left" id="bundle-tray-rotation">
                  <lang t="ARTICLE-BUNDLE-TRAY-ROTATION"></lang>
                </th>
                <th class="text-left" id="bundle-tray-orientation">
                  <lang t="ARTICLE-BUNDLE-TRAY-ORIENTATION"></lang>
                </th>
                <th id="default"></th>
                <!-- <th class="text-left"><lang t="ARTICLE-BUNDLE-TRAY-ICON"></lang></th> -->
              </tr>
            </thead>

            <tbody>
              <tr v-for="(tray, trayIndex) in bundle.trays" :key="tray.id">
                <td>{{ tray.name }}</td>
                <td>
                  <template v-if="tray.pivot.quantityOverride != null"
                    ><i>{{ tray.pivot.quantityOverride }}</i></template
                  >
                  <template v-else>{{ tray.pivot.quantity }}</template>
                  <v-icon
                    class="ml-2 "
                    :disabled="isReadonly"
                    plain
                    x-small
                    left
                    @click="editTray(trayIndex, 'quantityOverride', 'qty', tray.pivot.quantityOverride)"
                    >mdi-pencil</v-icon
                  >
                </td>
                <td>
                  <template v-if="tray.pivot.rotationOverride != null"
                    ><i>{{ tray.pivot.rotationOverride }}</i></template
                  >
                  <template v-else>{{ tray.pivot.rotation }}</template>
                  <v-icon
                    class="ml-2 "
                    :disabled="isReadonly"
                    plain
                    x-small
                    left
                    @click="editTray(trayIndex, 'rotationOverride', 'rotation', tray.pivot.rotationOverride)"
                    >mdi-pencil</v-icon
                  >
                </td>
                <td>
                  <template v-if="tray.pivot.orientationOverride != null"
                    ><i>{{ tray.pivot.orientationOverride }}</i></template
                  >
                  <template v-else>{{ tray.pivot.orientation }}</template>
                  <v-icon
                    class="ml-2 "
                    :disabled="isReadonly"
                    plain
                    x-small
                    left
                    @click="editTray(trayIndex, 'orientationOverride', 'orientation', tray.pivot.orientationOverride)"
                    >mdi-pencil</v-icon
                  >
                </td>
                <td>
                  <v-tooltip top v-if="tray.info && tray.info != ''">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
                    </template>
                    <span class="infoContainer" v-html="tray.info"></span>
                  </v-tooltip>
                </td>

                <!--
                     <td>
                         <v-img max-width="22px" max-height="20px" contain :src="$config.cdn + 'tray-'+tray.pivot.quantity+'-'+tray.pivot.rotation+'.png'">
                             <template v-slot:placeholder>
                                 <v-row class="fill-height ma-0" align="center" justify="center">
                                     <v-progress-circular size="16" width="2" indeterminate color="grey lighten-2"></v-progress-circular>
                                 </v-row>
                             </template>
                         </v-img>
                     </td>
                    -->
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </box>
    </template>
    <Dialog
      :dialogSettings="dialog"
      :itemEdited="editedItem"
      :propBundle="bundle"
      @closeModal="closeModal"
      @changeTray="changeTray"
      @changeAttribute="changeAttribute"
    />
    <v-dialog v-model="showConfirmation" :persistent="false" max-width="460">
      <v-card>
        <v-card-title>
          <span class="headline">Attention</span>
        </v-card-title>

        <v-card-text>{{ confirmationMsg }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmationDisagree"><lang t="GLOBAL-BTN-CANCEL"/></v-btn>
          <v-btn elevation="0" light rounded color="themeColor" @click="confirmationAgree"><lang t="GLOBAL-BTN-SET"/></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SubHeader from "@/components/ui-elements/SubHeader.vue";
import Box from "@/components/ui-elements/Box.vue";
import Dialog from "./Dialog.vue";
import { cloneDeep, isEqual } from "lodash";
import {EditAttributeDialogMixin} from '@/components/item/EditAttributeDialogMixin';
import ProductionSystem from '@/components/item/ProductionSystem.vue';
export default {
  name: "AttributeList",
  mixins: [EditAttributeDialogMixin],
  components: {
    SubHeader,
    Box,
    Dialog,
    ProductionSystem
  },
  props: {
    propBundle: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      bundle: null,
      showConfirmation: false,
      confirmationMsg: "",
    };
  },
  computed: {
    hasProductionLine() {
      const productionLine = this.items.find((el) => el.attribute.name == "productionline");
      return !productionLine ? false : true;
    },

    productionLineItems() {
      return this.items.filter((el) => el.attribute.name == "productionline");
    },
    filterItems() {
      return this.items.filter(
        (el) =>
          ![
            "bars",
            "quantity",
            "length_bars",
            "crushability_load",
            "width_bars",
            "narrowing",
            "weight",
            "fragile",
            "dangerous",
            "this_side_up",
            "width",
            "length",
            "height",
            "tolerance_height_plus",
            "tolerance_height_minus",
            "tolerance_length_minus",
            "tolerance_length_plus",
            "tolerance_width_plus",
            "tolerance_width_minus",
            "layers_glued",
            "foiled_type",
            "foiled",
            "trayheight",
            "displayside",
            "bottle_arrangement",
            "bottle_closure_ratio",
            "productionline",
            "articleNo",
            "slipsheet_inner",
            "friction",
            "adp_program",
            "kisoft_adp_program",
            "kisoft_adp_handling",
            "nesting_type",
            "nesting_bonus",
            "nesting_same_type_required",
            "bridge_percentage",
            "overhang_percentage",
            "transparent",
            "friction",
            "stamp_force",
            "strength",
            "loading_hint",
            "area_pressure",
            "tiltable",
            "adp_program",
            "nesting_type",
            "nesting_bonus",
            "kisoft_adp_handling",
            "nesting_same_type_required",
            "robot_program",
            "nesting_mix_sizes",
            "nesting_tolerance_plus",
            "nesting_tolerance_minus",
          ].includes(el.attribute.name)
      );
    },
  },
  watch: {
    propBundle: {
      handler() {
        this.setBundle();
      },
      deep: true,
      immediate: true,
    },
    bundle: {
      handler(newValue, oldValue) {
        if (oldValue !== null && !isEqual(this.propBundle, this.bundle)) this.$emit("updateBundle", this.bundle);
      },
      deep: true,
    },
  },
  created() {},
  methods: {
    setBundle() {
      this.bundle = cloneDeep(this.propBundle);
    },

    showTestResult(calculationId, bundleId) {
      this.$emit("showTestResult", calculationId, bundleId);
    },

    editTray(trayIndex, attrName, key, val) {
      this.editedItem = {
        trayIndex: trayIndex,
        attrName: attrName,
        name: key,
        key: key,
        value: val,
        clear: false,
      };

      if (key == "qty") {
        this.editedItem.options = [0, 1, 2];
      } else if (key == "rotation") {
        this.editedItem.options = [0, 90];
      } else if (key == "orientation") {
        this.editedItem.options = ["none", "length_left"];
      }

      this.dialog.type = "editTray";
      this.dialog.width = "640px";
      this.dialog.show = true;
    },

    changeTray(editedItem) {
      this.editedItem = cloneDeep(editedItem);
      if (this.editedItem.clear == true) {
        this.editedItem.value = null;
        this.$forceUpdate();
        this.closeModal();
      } else {
        let tray = this.bundle.trays[this.editedItem.trayIndex];

        let data = {
          bundle_id: this.bundle.id,
          quantity:
            this.editedItem.key == "qty"
              ? this.editedItem.value
              : this.bundle.trays[this.editedItem.trayIndex].pivot.quantityOverride ?? this.bundle.trays[this.editedItem.trayIndex].pivot.quantity,
          orientation:
            this.editedItem.key == "orientation"
              ? this.editedItem.value
              : this.bundle.trays[this.editedItem.trayIndex].pivot.orientationOverride ??
                this.bundle.trays[this.editedItem.trayIndex].pivot.orientation,
          rotation:
            this.editedItem.key == "rotation"
              ? this.editedItem.value
              : this.bundle.trays[this.editedItem.trayIndex].pivot.rotationOverride ?? this.bundle.trays[this.editedItem.trayIndex].pivot.rotation,
        };

        this.axios.post(this.$config.api + "/loadcarriers/" + tray.id + "/validatePattern", data).then((res) => {
          if (res.data.result === true) {
            this.$set(this.bundle.trays[this.editedItem.trayIndex].pivot, this.editedItem.attrName, this.editedItem.value);
            this.$forceUpdate();
            this.closeModal();
          } else {
            this.showConfirmation = true;
            this.confirmationMsg = res.data.result;
          }
        });
      }
    },

    confirmationAgree() {
      this.$set(this.bundle.trays[this.editedItem.trayIndex].pivot, this.editedItem.attrName, this.editedItem.value);
      this.closeConfirmationModal();
      this.closeModal();
      this.$forceUpdate();
    },

    confirmationDisagree() {
      this.closeConfirmationModal();
      this.closeModal();
    },

    closeConfirmationModal() {
      this.showConfirmation = false;
      this.confirmationMsg = "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
